var Organization;

import FieldMixins from './mixins/field_mixin.js';

export default Organization = Vue.extend({
  mixins: [FieldMixins],
  template: `<FieldView :editing='editing'
           :field='field'
           :field_groups='field_groups'
           :layouts='availableLayouts'
           ref='fieldView'>
  <template slot='content'>
    <div :class="(editing ? 'edit' : 'display') + '-content'">
      <div class="input-container inline">
        <div class="input-control right-addon">
          <input type="text" readonly placeholder='选择组织' />
          <div class="addon">
            <i class="slp-caret-down placeholder"></i>
          </div>
        </div>
      </div>
    </div>
  </template>
</FieldView>`
});
